import './maintenance.scss';

import queryString from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';
import { parseJwt } from '../../services/loginService';
import { getAllPlantsByRegion } from '../../services/plantService';
import { isAdmin } from '../../utils/generalUtils';
import { BasePage } from '../reusableComponents/BasePage';
import { ListPage } from '../reusableComponents/ListPage';
import { RegionFilter } from '../reusableComponents/RegionFilter';
import { ListItem } from './ListItem';

export interface IMaintenanceProps {
    instances: PlantModel[];
    history: IHistory;
    Access_Level: string;
    userId: string;
    location: {
        search: string;
    };
}

export interface IMaintenanceState {
    filterBy: string;
}

export class MaintenanceImpl extends React.Component<IMaintenanceProps, IMaintenanceState> {
    constructor(props: IMaintenanceProps) {
        super(props);
        let region = '';
        if (this.props.location.search) {
            region = queryString.parse(this.props.location.search).region;
        }
        this.state = { filterBy: region };
    }

    promise = async () => {
        const { userId } = this.props;
        if (PlantModel.list().length <= 1) {
            await getAllPlantsByRegion(this.props.userId, this.state.filterBy);
        }
    }

    renderAddPlantsButton = () => {
        return <div className="add-button" onClick={() => this.props.history.push('/maintenance/create')} >
            Add Plant <i className="fa fa-plus-square" aria-hidden="true"></i>
        </div>;
    }

    getFilteredInstances = async (filterName, value) => {
        this.props.history.push(`/maintenance?region=${value}`);
        await getAllPlantsByRegion(this.props.userId, value);
    }

    render() {
        return (
            <BasePage
                pageTitle="Maintenance"
                className="list-page-base"
                sideButton={isAdmin(this.props.Access_Level) ? this.renderAddPlantsButton() : <span />}
            >
                <ListPage
                    identifier="PlantListPage"
                    instances={this.props.instances}
                    listItemComponent={ListItem}
                    searchBy={['PlantId', 'Plant_Region', 'State']}
                    instanceOf={'plantInfo'}
                    pageHeadings={['Plant ID', 'Region', 'State']}
                    promise={this.promise}
                    cols={[4, 4, 4]}
                    searchPlaceHolder="Enter plantId, state or region to filter..."
                    emptyListMessage="No Plants found"
                    chartFilter={<RegionFilter
                        selectedValue={this.state.filterBy}
                        onChange={this.getFilteredInstances}
                    />}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    const instances = PlantModel.list();
    const userId = state.login.get('UniqueId');
    const Access_Level = parseJwt(state.login.get('token')).Access_Level;
    return {
        userId, instances, Access_Level
    };
}
export const Maintenance = withRouter(connect<{}, {}, IMaintenanceProps>(mapStateToProps)(MaintenanceImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Maintenance/index.tsx